<template>
  <div class="quiz-view">
    <QuizLayout>
      <template v-slot:content>
        <QuizColumn />
      </template>
      <template v-slot:footer>
        <span class="quiz-view__disclaimer-text">
          {{ testViewSettings.footer_text }}
        </span>
      </template>
    </QuizLayout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QuizLayout from "@/layouts/QuizLayout";
import QuizColumn from "@/containers/QuizColumn";
import store from "@/store";

export default {
  name: "QuizView",
  components: {
    QuizLayout,
    QuizColumn
  },
  created() {
    store.commit("resetQuestionQueue");
  },
  computed: {
    ...mapState({
      testViewSettings: state => state.testViewSettings
    })
  }
};
</script>

<style lang="scss" scoped>
.quiz-view {
  display: block;
  height: 100%;

  &__disclaimer-text {
    color: theme-color("inactive");
    font-size: px-to-rem(12px);

    @include if-tablet {
      font-size: px-to-rem(14px);
    }
  }
}
</style>
